
<app-modal #feedbackModal  [visibleTop]="60" [hideFooter] = "true" class="without-border bg-color-black full-width-modal">
  <div class="app-modal-header">
      <div class="text-normal">
          {{'rate'|translate}}
      </div>
  </div>
  <div class="app-modal-body text-center" >
    <label class="text-normal">{{'pleaseRate'|translate}}</label>
    <div class="rating">
      <input type="checkbox" name="rating" id="r1" [checked] = "selectEvaluateValue >= 1" (click)="selectEvaluate(1)">
      <label for="r1"></label>

      <input type="checkbox" name="rating" id="r2" [checked] = "selectEvaluateValue >= 2" (click)="selectEvaluate(2)">
      <label for="r2"></label>

      <input type="checkbox" name="rating" id="r3" [checked] = "selectEvaluateValue >= 3" (click)="selectEvaluate(3)">
      <label for="r3"></label>

      <input type="checkbox" name="rating" id="r4" [checked] = "selectEvaluateValue >= 4" (click)="selectEvaluate(4)">
      <label for="r4"></label>

      <input type="checkbox" name="rating" id="r5" [checked] = "selectEvaluateValue === 5" (click)="selectEvaluate(5)">
      <label for="r5"></label>

    </div>

    <div class="">
      <label>{{'feedback'|translate}}</label>
      <textarea class="opinion" [ngModel]="message" (ngModelChange)="doTextarea($event)"></textarea>
    </div>
    <div class="text-center">
      <app-primary-button [text]="'doRate' | translate" (onClick)="onSubmit()" ></app-primary-button>
    </div>
  </div>



</app-modal>
